<template>
<div class="chapter">
<div class="inner_page">
<table border="0" cellpadding="0" cellspacing="0" width="100%">
<tbody><tr>
<td class="border2" style="width:10%" valign="middle"><h2 class="h2"><a id="page_19"></a><a id="part2"></a>PART<br/>TWO</h2></td>
<td style="width:80%" valign="top"><h2 class="h2a">A Blessed<br/>Beginning</h2></td>
</tr>
<tr>
<td class="border" valign="top"><h2 class="h2a"> </h2></td>
<td valign="top"><p class="blockquotex"><em>“James, you are scheduled to graduate in three months. Three months of silent treatment is nothing. I believe I could live in hell for three months if I knew I was going to get out.” And, as if to underscore the lack of manhood I was exhibiting, she continued, “and I’m a woman.”</em><a id="page_20"></a></p></td>
</tr>
</tbody></table>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// part02.vue?1fc47f5e